webpackJsonp([248416857800033],{

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	module.exports=function(e){var t={};function n(r){if(t[r])return t[r].exports;var a=t[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,n),a.l=!0,a.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:r})},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=11)}([function(e,t){e.exports=__webpack_require__(1)},function(e,t){e.exports=__webpack_require__(3)},function(e,t){e.exports=__webpack_require__(13)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=l(n(0)),a=l(n(2)),o=n(1);function l(e){return e&&e.__esModule?e:{default:e}}var i=function(e){var t=e.className,n=e.children,o=e.colSpan,l=(0,a.default)("ep-section__header__content",t);return r.default.createElement("tr",{className:l},r.default.createElement("td",{colSpan:o},n))};i.propTypes={colSpan:o.number,children:o.node.isRequired,className:o.string},i.defaultProps={colSpan:1,className:""},t.default=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r,a,o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),i=c(l),s=n(1),u=c(n(2));function c(e){return e&&e.__esModule?e:{default:e}}var d=(a=r=function(e){function t(){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,l.PureComponent),o(t,[{key:"btnTypeClass",value:function(){switch(this.props.type){case"apply":return this.props.baseStyle+"-btn-apply";case"cancel":return this.props.baseStyle+"-btn-cancel";default:return null}}},{key:"btnContent",value:function(){var e={label:{},icon:{}};this.props.icon&&this.props.alignIcon&&(this.props.iconAfter?(e.label={float:"left"},e.icon={float:"right"}):(e.label={float:"right"},e.icon={float:"left"}));var t=i.default.createElement("span",{key:"label",className:this.props.baseStyle+"-btn-label",style:e.label},this.props.label);if(this.props.icon){var n=[t,i.default.createElement("div",{key:"icon",className:this.props.baseStyle+"-btn-icon",style:e.icon},this.props.icon)];return this.props.iconAfter?n:n.reverse()}return t}},{key:"render",value:function(){var e=(0,u.default)(this.props.baseStyle+"-btn",this.btnTypeClass(),this.props.className);return i.default.createElement("button",{className:e,disabled:this.props.disabled,style:this.props.style,onClick:this.props.onClick,onFocus:this.props.onFocus,onBlur:this.props.onBlur,"data-tip":this.props.tooltip||""},this.btnContent())}}]),t}(),r.propTypes={baseStyle:s.string,className:s.string,style:(0,s.objectOf)((0,s.oneOfType)([s.string,s.number])),type:s.string,disabled:s.bool,label:s.string.isRequired,icon:(0,s.oneOfType)([s.element,s.string]),iconAfter:s.bool,alignIcon:s.bool,onClick:s.func.isRequired,onFocus:s.func,onBlur:s.func,tooltip:s.string},r.defaultProps={baseStyle:"ep",className:"",disabled:!1,style:{},type:"",icon:null,iconAfter:!0,alignIcon:!0,onFocus:function(){return null},onBlur:function(){return null},tooltip:""},a);t.default=d},function(e,t){e.exports=__webpack_require__(4)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=i(n(0)),a=i(n(2)),o=n(1),l=i(n(25));function i(e){return e&&e.__esModule?e:{default:e}}var s=function(e){var t=e.index,n=e.className,o=(0,a.default)("counter",n);return r.default.createElement("div",{className:o},r.default.createElement(l.default,null),r.default.createElement("div",{className:"counter_number"},t))};s.propTypes={className:o.string,index:o.number.isRequired},s.defaultProps={className:""},t.default=s},function(e,t,n){var r=n(0);function a(e){return r.createElement("svg",e,[r.createElement("title",{key:0}),r.createElement("g",{id:"icomoon-ignore",key:1}),r.createElement("path",{d:"M75.244 178.171h981.209c34.736 0 60.778 26.045 60.778 60.778 0 17.367-8.681 26.045-17.367 43.409l-486.258 555.729c-26.045 26.045-60.778 26.045-86.838 0 0 0 0 0 0 0l-494.951-555.729c-26.045-26.045-17.367-60.778 8.681-86.838 0-8.681 17.367-17.367 34.736-17.367z",key:2})])}a.displayName="ArrowDown",a.defaultProps={version:"1.1",width:"1123",height:"1024",viewBox:"0 0 1123 1024"},e.exports=a,a.default=a},function(e,t){e.exports=__webpack_require__(14)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=/[A-Z]/g,a=/[-_\s]+/g;function o(e){return null===e||void 0===e?"":""+e}t.default={startsWith:function(e,t){var n=o(e),r=o(t);return 0===n.indexOf(r)},endsWith:function(e,t){var n=o(e),r=o(t),a=n.length-r.length;return a>=0&&n.indexOf(r,a)===a},dasherize:function(e){return o(e).trim().replace(r,"-$1").replace(a,"-").toLowerCase()}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=function(){return function(e,t){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return function(e,t){var n=[],r=!0,a=!1,o=void 0;try{for(var l,i=e[Symbol.iterator]();!(r=(l=i.next()).done)&&(n.push(l.value),!t||n.length!==t);r=!0);}catch(e){a=!0,o=e}finally{try{!r&&i.return&&i.return()}finally{if(a)throw o}}return n}(e,t);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),l=d(n(0)),i=d(n(1)),s=d(n(34)),u=d(n(8)),c=d(n(9));function d(e){return e&&e.__esModule?e:{default:e}}function p(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var f=/\.\.\//g,b=/[.:]/;t.default=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"";return function(t){var n,d,h=function(t,n){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},l=function(e){return"\0"+e+"\0"},i=u.default.extend({},r,u.default.chain(a).keys().reduce(function(e,t){return e[t]=l(t),e},{}).value()),d=t(function(t){if(c.default.startsWith(t,"/"))return t.substr(1,t.length);if(c.default.startsWith(t,"../")){var n=e.split(b);if(1===n.length)return t;var r=t.match(f).length,a=t.replace(f,"");return n.slice(0,n.length-r).concat([a]).join(".").replace(".",":")}if(e.length){var o=c.default.endsWith(e,":")?"":".";return""+e+o+t}return t}(n),i);if(!u.default.isEmpty(a)){var h=u.default.chain(a).pairs().reduce(function(e,t){var n,r=o(e,2),a=r[0],i=r[1],s=o(t,2),c=s[0],d=s[1],f=a.split(l(c)),b=(p(n={},"text_"+c,f[0]),p(n,"comp_"+c,d),n);return[f[1],u.default.extend(i,b)]},[d,{}]).value(),m=o(h,2),y=m[0],v=m[1];return v.last=y,(0,s.default)(v)}return d};return d=n=function(e){function n(){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(n.__proto__||Object.getPrototypeOf(n)).apply(this,arguments))}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(n,l.default.PureComponent),a(n,[{key:"render",value:function(){var e=this.props,n=e.i18n,a=function(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}(e,["i18n"]),o=this.context.i18n,i=window.$&&window.$.t,s=n||o||i||function(e){return e};return l.default.createElement(t,r({i18n:u.default.partial(h,s)},a))}}]),n}(),n.propTypes={i18n:i.default.func},n.defaultProps={i18n:null},n.contextTypes={i18n:i.default.func},d}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.version=t.translate=t.TextAreaWithApply=t.IconButton=t.CustomSelect=t.DataTableHeaderCell=t.DataTableHeader=t.DataTableCell=t.DataTableRow=t.DataTableBody=t.DataTable=t.SectionHeaderWithCounter=t.SectionHeaderWithCounterAndExpand=t.SectionHeader=t.SectionRow=t.RadioButtonList=t.DynamicHeightContainer=t.CellWithTitle=t.CardContent=t.CardHeader=t.Card=t.QuestionsGroup=t.Button=void 0;var r=n(12);Object.defineProperty(t,"DataTable",{enumerable:!0,get:function(){return r.DataTable}}),Object.defineProperty(t,"DataTableBody",{enumerable:!0,get:function(){return r.DataTableBody}}),Object.defineProperty(t,"DataTableRow",{enumerable:!0,get:function(){return r.DataTableRow}}),Object.defineProperty(t,"DataTableCell",{enumerable:!0,get:function(){return r.DataTableCell}}),Object.defineProperty(t,"DataTableHeader",{enumerable:!0,get:function(){return r.DataTableHeader}}),Object.defineProperty(t,"DataTableHeaderCell",{enumerable:!0,get:function(){return r.DataTableHeaderCell}});var a=n(13);Object.defineProperty(t,"version",{enumerable:!0,get:function(){return a.version}}),n(14);var o=O(n(4)),l=O(n(15)),i=O(n(16)),s=O(n(17)),u=O(n(18)),c=O(n(19)),d=O(n(20)),p=O(n(21)),f=O(n(23)),b=O(n(3)),h=O(n(24)),m=O(n(28)),y=O(n(29)),v=O(n(31)),g=O(n(33)),_=O(n(10));function O(e){return e&&e.__esModule?e:{default:e}}t.Button=o.default,t.QuestionsGroup=l.default,t.Card=i.default,t.CardHeader=s.default,t.CardContent=u.default,t.CellWithTitle=c.default,t.DynamicHeightContainer=d.default,t.RadioButtonList=p.default,t.SectionRow=f.default,t.SectionHeader=b.default,t.SectionHeaderWithCounterAndExpand=h.default,t.SectionHeaderWithCounter=m.default,t.CustomSelect=y.default,t.IconButton=v.default,t.TextAreaWithApply=g.default,t.translate=_.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.DataTable=t.DataTableBody=t.DataTableHeader=t.DataTableRow=t.DataTableHeaderCell=t.DataTableCell=void 0;var r,a,o,l,i,s,u,c,d,p,f,b,h=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),m=n(0),y=_(m),v=n(1),g=_(n(2));function _(e){return e&&e.__esModule?e:{default:e}}function O(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function w(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function N(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.DataTableCell=(a=r=function(e){function t(){return O(this,t),w(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return N(t,m.PureComponent),h(t,[{key:"cellContent",value:function(){switch(this.props.type){case"string":case"number":return this.props.value;case"custom":return this.props.children;default:return this.props.value}}},{key:"render",value:function(){return y.default.createElement("td",{className:(0,g.default)("ep-data-table-cell",this.props.className)},this.cellContent())}}]),t}(),r.propTypes={className:v.string,type:(0,v.oneOf)(["string","number","custom"]),value:(0,v.oneOfType)([v.string,v.number]),children:v.node},r.defaultProps={className:"",type:"string",value:null,children:null},a),t.DataTableHeaderCell=(l=o=function(e){function t(){return O(this,t),w(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return N(t,m.PureComponent),h(t,[{key:"render",value:function(){return y.default.createElement("th",{className:(0,g.default)("ep-data-table-head-cell",this.props.className)},this.props.children)}}]),t}(),o.propTypes={children:v.node.isRequired,className:v.string},o.defaultProps={className:""},l),t.DataTableRow=(s=i=function(e){function t(){return O(this,t),w(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return N(t,m.PureComponent),h(t,[{key:"render",value:function(){return y.default.createElement("tr",{className:(0,g.default)("ep-data-table-row",this.props.className)},this.props.children)}}]),t}(),i.propTypes={children:v.node.isRequired,className:v.string},i.defaultProps={className:""},s),t.DataTableHeader=(c=u=function(e){function t(){return O(this,t),w(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return N(t,m.PureComponent),h(t,[{key:"render",value:function(){return y.default.createElement("thead",{className:(0,g.default)("ep-data-table-header",this.props.className)},this.props.children)}}]),t}(),u.propTypes={children:v.node.isRequired,className:v.string},u.defaultProps={className:""},c),t.DataTableBody=(p=d=function(e){function t(){return O(this,t),w(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return N(t,m.PureComponent),h(t,[{key:"render",value:function(){return y.default.createElement("tbody",{className:(0,g.default)("ep-data-table-body",this.props.className)},y.default.Children.map(this.props.children,function(e){return e}))}}]),t}(),d.propTypes={children:v.node.isRequired,className:v.string},d.defaultProps={className:""},p),t.DataTable=(b=f=function(e){function t(){return O(this,t),w(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return N(t,m.PureComponent),h(t,[{key:"render",value:function(){var e=(0,g.default)("ep-data-table",this.props.type,this.props.className);return y.default.createElement("table",{className:e},this.props.children)}}]),t}(),f.propTypes={className:v.string,children:v.node.isRequired,type:(0,v.oneOf)(["","stripped"])},f.defaultProps={className:"",type:""},b)},function(e,t){e.exports={name:"@ep/react-components",version:"0.5.3",description:"Common React Components Library",main:"app/main.js",scripts:{"build:dev":"jest && webpack","build:prod":"jest && cross-env NODE_ENV=production webpack","build:umd":"cross-env NODE_ENV=production webpack --config scripts/umd.webpack.config","build:copy":"node ./scripts/copy-build-files.js",prebuild:"rm -rf ./dist",build:"yarn build:prod && yarn build:umd && yarn build:copy",release:"yarn build && npm publish dist",start:"webpack-dev-server --hot --progress --colors --inline",test:"jest","test:watch":"jest --watch","//":"updateSnap script updates snapshots but for some reason return code 1","test:updateSnap":"jest -u --testNamePattern",lint:"eslint app; exit 0"},jest:{moduleNameMapper:{"\\.(jpg|jpeg|png|gif|eot|otf|webp|svg|ttf|woff|woff2|mp4|webm|wav|mp3|m4a|aac|oga)$":"<rootDir>/app/components/__mocks__/fileMock.js","\\.(css|less)$":"<rootDir>/app/components/__mocks__/styleMock.js"}},author:"Evidence Prime",license:"ISC",dependencies:{underscore:"^1.9.1"},peerDependencies:{classnames:"^2.2.5",immutable:"^3.8.2","prop-types":"^15.6.1",react:"*","react-addons-create-fragment":"^15.6.2"},devDependencies:{"babel-core":"^6.26.0","babel-eslint":"^8.0.1","babel-jest":"^22.4.1","babel-loader":"^7.1.2","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-preset-env":"^1.6.1","babel-preset-es2015":"^6.18.0","babel-preset-react":"^6.16.0","babel-preset-stage-0":"^6.16.0","copy-webpack-plugin":"^4.5.1",classnames:"^2.2.5","cross-env":"^3.1.4","css-loader":"^0.26.1",enzyme:"^3.3.0","enzyme-adapter-react-16":"^1.1.1",eslint:"^4.8.0","eslint-config-airbnb":"^16.1.0","eslint-loader":"^1.9.0","eslint-plugin-import":"^2.8.0","eslint-plugin-jsx-a11y":"^6.0.3","eslint-plugin-react":"^7.5.1","extract-text-webpack-plugin":"^3.0.2","file-loader":"^0.9.0","fs-extra":"^6.0.1","html-webpack-plugin":"^2.30.1",i18next:"^11.1.1","i18next-xhr-backend":"^1.5.1","image-webpack-loader":"^3.1.0",immutable:"^3.8.2",jest:"^22.1.4","prop-types":"^15.6.1",react:"^16.4.0","react-addons-create-fragment":"^15.6.2","react-dom":"^16.4.0","react-hot-loader":"^3.1.3","react-test-renderer":"^16.2.0","style-loader":"^0.13.1",stylus:"^0.54.5","stylus-loader":"^2.4.0","svg-react-loader":"^0.4.5","uglifyjs-webpack-plugin":"^1.2.5","url-loader":"^1.0.1",webpack:"^3.10.0","webpack-dev-server":"^2.11.1"}}},function(e,t){},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},a=i(n(0)),o=i(n(1)),l=i(n(2));function i(e){return e&&e.__esModule?e:{default:e}}var s=function(e){var t=e.className,n=function(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}(e,["className"]);return a.default.createElement("div",r({className:(0,l.default)("ep-questions-group",t)},n))};s.propTypes={className:o.default.string},s.defaultProps={className:""},t.default=s},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=l(n(0)),a=l(n(2)),o=l(n(1));function l(e){return e&&e.__esModule?e:{default:e}}var i=function(e){var t=e.children,n=e.className,o=e.style;return r.default.createElement("div",{className:(0,a.default)("ep-card",n),style:o},t)};i.propTypes={children:o.default.node.isRequired,className:o.default.string,style:o.default.object},i.defaultProps={className:"",style:{}},t.default=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=o(n(0)),a=o(n(1));function o(e){return e&&e.__esModule?e:{default:e}}var l=function(e){var t=e.title,n=e.children;return r.default.createElement("div",{className:"card__card-header"},t&&r.default.createElement("h1",null,t),n)};l.propTypes={title:a.default.string,children:a.default.node},l.defaultProps={title:null,children:null},t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=l(n(0)),a=l(n(1)),o=l(n(2));function l(e){return e&&e.__esModule?e:{default:e}}var i=function(e){var t=e.className,n=e.headerBackground,a=e.children;return r.default.createElement("div",{className:(0,o.default)("card__card-content",t,{"header-bg":n})},a)};i.propTypes={className:a.default.string,children:a.default.node.isRequired,headerBackground:a.default.bool},i.defaultProps={className:"",headerBackground:!1},t.default=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=l(n(0)),a=l(n(2)),o=n(1);function l(e){return e&&e.__esModule?e:{default:e}}var i=function(e){var t=e.className,n=e.rowSpan,o=e.colSpan,l=e.children,i=e.cellTitle,s=e.style,u=(0,a.default)("ep-cell",t);return r.default.createElement("td",{colSpan:o,rowSpan:n,className:u,style:s},i&&r.default.createElement("h2",null,i),r.default.createElement("div",{className:"ep-cell__content"},l))};i.propTypes={className:o.string,cellTitle:o.string,children:o.node.isRequired,colSpan:o.number,rowSpan:o.number,style:o.object},i.defaultProps={className:"",rowSpan:1,colSpan:1,cellTitle:null,style:{}},t.default=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r,a,o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=u(n(0)),i=u(n(2)),s=u(n(1));function u(e){return e&&e.__esModule?e:{default:e}}var c={childList:!0,subtree:!0,characterData:!0,attributes:!0},d=(a=r=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var n=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.container=null,n.innerContainer=null,n._ref=n._ref.bind(n),n._refInner=n._refInner.bind(n),n.updateContainerHeight=n.updateContainerHeight.bind(n),n.handleTransitionEnd=n.handleTransitionEnd.bind(n),n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,l.default.Component),o(t,[{key:"componentDidMount",value:function(){this.updateContainerHeight(),window.MutationObserver&&(this.observer=new window.MutationObserver(this.updateContainerHeight),this.observer.observe(this.innerContainer,c))}},{key:"componentDidUpdate",value:function(e,t){this.observer||this.updateContainerHeight()}},{key:"componentWillUnmount",value:function(){this.observer&&(this.observer.disconnect(),this.observer=null)}},{key:"_ref",value:function(e){this.container=e}},{key:"_refInner",value:function(e){this.innerContainer=e}},{key:"updateContainerHeight",value:function(e){var t=this.innerContainer.scrollHeight;this.container.style.height=t+"px"}},{key:"handleTransitionEnd",value:function(e){e.target.classList.contains("ep-dynamic-height-container")&&this.updateContainerHeight()}},{key:"render",value:function(){return l.default.createElement("div",{className:(0,i.default)("ep-dynamic-height-container",this.props.className),ref:this._ref,onTransitionEnd:this.handleTransitionEnd},l.default.createElement("div",{className:"ep-dynamic-height-container__inner",ref:this._refInner},this.props.children))}}]),t}(),r.propTypes={children:s.default.node.isRequired,className:s.default.string},r.defaultProps={className:""},a);t.default=d},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=s(n(0)),a=n(1),o=s(n(5)),l=s(n(2)),i=s(n(22));function s(e){return e&&e.__esModule?e:{default:e}}var u=function(e){var t=e.name,n=e.editable,a=e.additionalOptions,o=e.selectedOption,s=e.options,u=e.onChange,c=e.className,d=e.sectionId,p=(0,l.default)("ep-radiobuttonlist-fieldset",c);return r.default.createElement("fieldset",{name:t,disabled:!n,className:p},s.map(function(e){return r.default.createElement(i.default,{key:e.get("value"),onChange:u,option:e,sectionId:d,selectedOption:o})}).toList(),!a.isEmpty()&&r.default.createElement("hr",null),a.map(function(e){return r.default.createElement(i.default,{key:e.get("value"),onChange:u,option:e,sectionId:d,selectedOption:o})}).toList())};u.propTypes={additionalOptions:(0,a.instanceOf)(o.default.List),className:a.string,editable:a.bool,name:a.string.isRequired,onChange:a.func,options:(0,a.instanceOf)(o.default.List).isRequired,sectionId:a.string.isRequired,selectedOption:a.string},u.defaultProps={additionalOptions:o.default.List(),onChange:function(){return null},editable:!0,className:"",selectedOption:""},t.default=u},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=l(n(0)),a=l(n(5)),o=n(1);function l(e){return e&&e.__esModule?e:{default:e}}var i=function(e){var t=e.option,n=e.onChange,a=e.selectedOption;return r.default.createElement("label",null,r.default.createElement("input",{type:"radio",value:t.get("value"),checked:t.get("value")===a,onChange:n}),r.default.createElement("span",{className:"option-label"},t.get("text")),r.default.createElement("br",null))};i.propTypes={option:(0,o.instanceOf)(a.default.Map).isRequired,onChange:o.func.isRequired,selectedOption:o.string},i.defaultProps={selectedOption:null},t.default=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=l(n(0)),a=l(n(2)),o=n(1);function l(e){return e&&e.__esModule?e:{default:e}}var i=function(e){var t=e.children,n=e.className,o=e.style;return r.default.createElement("tr",{className:(0,a.default)("ep-section-row",n),style:o},t)};i.propTypes={children:o.node.isRequired,className:o.string,style:o.object},i.defaultProps={className:"",style:{}},t.default=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=s(n(0)),a=n(1),o=s(n(6)),l=s(n(26)),i=s(n(3));function s(e){return e&&e.__esModule?e:{default:e}}var u=function(e){var t=e.className,n=e.children,a=e.colSpan,s=e.expanded,u=e.index,c=e.withIndex,d=e.onToggle,p=e.withToggle;return r.default.createElement(i.default,{className:t,colSpan:a},u&&c&&r.default.createElement(o.default,{className:"ep-section__header",index:u}),n,p&&r.default.createElement(l.default,{expanded:s,onClick:d}))};u.propTypes={className:a.string,children:a.node.isRequired,colSpan:a.number,expanded:a.bool,index:a.number,onToggle:a.func.isRequired,withIndex:a.bool,withToggle:a.bool},u.defaultProps={className:"",colSpan:1,expanded:!0,index:1,withIndex:!0,withToggle:!0},t.default=u},function(e,t,n){var r=n(0);function a(e){return r.createElement("svg",e,[r.createElement("defs",{key:0},r.createElement("style",null,".cls-1{fill:#ffb563;}.cls-2{fill:#ffa746;}")),r.createElement("title",{key:1},"circle"),r.createElement("g",{id:"Layer_2","data-name":"Layer 2",key:2},r.createElement("g",{id:"Layer_1-2","data-name":"Layer 1"},[r.createElement("path",{className:"cls-1",d:"M0,22A22,22,0,0,0,22,44V0A22,22,0,0,0,0,22Z",key:0}),r.createElement("path",{className:"cls-2",d:"M44,22A22,22,0,0,0,22,0V44A22,22,0,0,0,44,22Z",key:1})]))])}a.displayName="Circle",a.defaultProps={viewBox:"0 0 44 44"},e.exports=a,a.default=a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=s(n(2)),a=s(n(0)),o=n(1),l=s(n(27)),i=s(n(7));function s(e){return e&&e.__esModule?e:{default:e}}var u=function(e){var t=e.className,n=e.expanded,o=e.onClick,s=(0,r.default)("ep-expand-button",t,{"ep-expand-button--expanded":n,"ep-expand-button--collapsed":!n});return a.default.createElement("button",{onClick:o,className:s},n?a.default.createElement(l.default,null):a.default.createElement(i.default,null))};u.propTypes={className:o.string,expanded:o.bool,onClick:o.func.isRequired},u.defaultProps={className:"",expanded:!0},t.default=u},function(e,t,n){var r=n(0);function a(e){return r.createElement("svg",e,[r.createElement("title",{key:0}),r.createElement("g",{id:"icomoon-ignore",key:1}),r.createElement("path",{d:"M1020.629 847.476h-944.613c-0.142 0.002-0.305 0.003-0.472 0.003-31.833 0-57.623-25.8-57.623-57.623 0-14.788 5.569-28.275 14.723-38.48l471.004-538.65c10.517-11.041 25.341-17.919 41.754-17.919s31.237 6.874 41.742 17.888l475.248 538.725c9.118 10.146 14.686 23.638 14.686 38.435 0 31.413-25.133 56.958-56.39 57.618z",key:2})])}a.displayName="ArrowUp",a.defaultProps={version:"1.1",width:"1095",height:"1024",viewBox:"0 0 1095 1024"},e.exports=a,a.default=a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=i(n(0)),a=n(1),o=i(n(3)),l=i(n(6));function i(e){return e&&e.__esModule?e:{default:e}}var s=function(e){var t=e.className,n=e.children,a=e.colSpan,i=e.index,s=e.withIndex;return r.default.createElement(o.default,{className:t,colSpan:a},i&&s&&r.default.createElement(l.default,{className:"ep-section__header",index:i}),n)};s.propTypes={colSpan:a.number,index:a.number,children:a.node.isRequired,withIndex:a.bool,className:a.string},s.defaultProps={colSpan:1,withIndex:!0,index:1,className:""},t.default=s},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r,a,o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=p(n(0)),i=n(1),s=p(n(2)),u=p(n(8)),c=p(n(9)),d=p(n(7));function p(e){return e&&e.__esModule?e:{default:e}}n(30);var f=(0,i.shape)({value:i.string,text:i.string,disabled:i.bool,tooltip:i.string}),b=(a=r=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var n=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n.onBlur=function(){n.container.contains(document.activeElement)||n.setState({showingOptions:!1})},n.onOptionOver=function(e){if(n.props.onOptionHover){var t=e.target.getAttribute("data-value");n.props.onOptionHover(t,e.target)}},n.onOptionOut=function(){"function"==typeof n.props.onOptionHover&&n.props.onOptionHover(null)},n.getInitiallySelectedText=function(e){var t=e.selected,n=e.groupedOptions,r=e.options;if(t){var a=u.default.flatten(r.concat(u.default.pluck(n,"options"))),o=u.default.findWhere(a,{value:t});return o?o.text:"&zwnj;"}return"&zwnj;"},n.handleSelect=function(e){return function(t){t.stopPropagation(),t.preventDefault(),e.disabled||(e.value!==n.state.selectedValue?(n.setState({selectedValue:e.value,selectedText:e.text,showingOptions:!1}),"function"==typeof n.props.onChange&&n.props.onChange(e.value)):n.setState({showingOptions:!1}))}},n.listRef=function(e){n.listEl=e},n.toggleOptions=function(){n.props.disabled||n.setState({showingOptions:!n.state.showingOptions})},n.renderOptionsGroup=function(e,t){var r=e.caption,a=e.options;return l.default.createElement("li",{className:"options-group",key:t},l.default.createElement("div",{className:"options-group__caption"},r),l.default.createElement("div",{className:"options-group__options"},l.default.createElement("ul",null,a.map(n.renderOption))))},n.renderOption=function(e,t){var r=e.value,a=e.text,o=e.disabled,i=e.tooltip,u=n.state.selectedValue===r,d=(0,s.default)("option",c.default.dasherize(r),{selected:u});return l.default.createElement("li",{className:d,tabIndex:"1","data-index":t,"data-value":r,onMouseDown:n.handleSelect(e),key:t,disabled:o,"data-tip":i||""},a)},n.renderSign=function(){var e=n.props,t=e.signClass,r=e.signPosition,a="full-triangle"===t?l.default.createElement(d.default,null):"",o=(0,s.default)("select-sign",t,{left:"left"===r,right:"right"===r});return l.default.createElement("div",{className:o},a)},n.state={selectedValue:e.selected,selectedText:n.getInitiallySelectedText(e),showingOptions:!1},n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,l.default.PureComponent),o(t,[{key:"componentDidUpdate",value:function(e,t){var n=this.state,r=n.selectedValue,a=n.showingOptions;if(r||this.setState({selectedText:this.getInitiallySelectedText(this.props)}),a&&!t.showingOptions){var o=this.container.getBoundingClientRect(),l=o.top,i=o.height;this.listEl.setAttribute("style","max-height:calc(100vh - "+(l+i+5)+"px);overflow:auto;")}}},{key:"render",value:function(){var e=this,t=(0,s.default)("options-select-container",this.props.className,{expanded:this.state.showingOptions,disabled:this.props.disabled}),n=(0,s.default)("options-container",this.props.listClassName,{visible:this.state.showingOptions,"with-numbered-options":this.props.withNumberOptions}),r=this.props.orderedList?"ol":"ul";return l.default.createElement("div",{className:t,ref:function(t){e.container=t}},l.default.createElement("div",{className:"select-input",onClick:this.toggleOptions,tabIndex:"1",onBlur:this.onBlur},"left"===this.props.signPosition&&this.renderSign(),l.default.createElement("div",{className:"text-box",dangerouslySetInnerHTML:{__html:this.state.selectedText}}),"right"===this.props.signPosition&&this.renderSign()),l.default.createElement(r,{className:n,onMouseOver:this.onOptionOver,onMouseLeave:this.onOptionOut,ref:this.listRef},this.props.groupedOptions.map(this.renderOptionsGroup),this.props.options.map(this.renderOption)))}}]),t}(),r.propTypes={className:i.string,onChange:i.func,onOptionHover:i.func,signPosition:(0,i.oneOf)(["left","right"]),signClass:i.string,listClassName:i.string,options:(0,i.arrayOf)(f),groupedOptions:(0,i.arrayOf)((0,i.shape)({caption:i.string,options:(0,i.arrayOf)(f)})),selected:i.string,disabled:i.bool,orderedList:i.bool,withNumberOptions:i.bool},r.defaultProps={signPosition:"right",orderedList:!1,withNumberOptions:!1,groupedOptions:[],options:[]},a);t.default=b},function(e,t){},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=l(n(0)),a=l(n(1)),o=l(n(2));function l(e){return e&&e.__esModule?e:{default:e}}n(32);var i=function(e){var t=e.iconName,n=e.label,a=e.disabled,l=e.displayLabel,i=e.title,s=e.className,u=e.onClick,c=(0,o.default)(s,"btn-icon-container",{disabled:a}),d=(0,o.default)("btn","btn-icon",t,{disabled:a});return r.default.createElement("div",{className:c,onClick:function(e){a||u(e)}},r.default.createElement("div",{className:d,"data-tip":i}),l&&r.default.createElement("div",{className:"label-text"},n))};i.propTypes={iconName:a.default.string.isRequired,onClick:a.default.func,label:a.default.string,disabled:a.default.bool,displayLabel:a.default.bool,title:a.default.string,className:a.default.string},i.defaultProps={onClick:function(){},label:null,title:null,className:null,disabled:!1,displayLabel:!1},t.default=i},function(e,t){},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r,a,o,l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=p(n(0)),s=p(n(1)),u=p(n(2)),c=p(n(10)),d=p(n(4));function p(e){return e&&e.__esModule?e:{default:e}}n(35);var f=(0,c.default)()((o=a=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var n=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n.onApply=function(){n.props.onApply(n.textArea.value),n.close()},n.onBlur=function(e){return e.stopPropagation(),e.relatedTarget&&e.relatedTarget.classList.contains("gdt-btn-cancel")?n.onCancel():n.onApply()},n.onCancel=function(){var e=n.props,t=e.onCancel,r=e.onApply;t?t():n.initialContent&&n.initialContent!==n.textArea.value&&r(n.initialContent),n.close()},n.close=function(){n.initialContent=null,n.mounted&&n.setState({editing:!1})},n.textAreaRef=function(e){n.textArea=e},n.startEditing=function(){n.props.readOnly||n.setState({editing:!0})},n.state={editing:!e.readOnly&&e.editing},n.mounted=!1,n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,i.default.PureComponent),l(t,[{key:"componentDidMount",value:function(){this.mounted=!0}},{key:"componentWillUpdate",value:function(e,t){!this.state.editing&&t.editing&&(this.initialContent=this.props.content)}},{key:"componentWillUnmount",value:function(){this.mounted=!1}},{key:"render",value:function(){var e=this.props,t=e.i18n,n=e.content,r=e.readOnly,a=this.state.editing,o=(0,u.default)({editing:a,readOnly:r,"text-area-container":!0});return a?i.default.createElement("div",{className:o},i.default.createElement("textarea",{ref:this.textAreaRef,defaultValue:n,onBlur:this.onBlur,autoFocus:!0}),i.default.createElement("div",{className:"buttons"},i.default.createElement(d.default,{type:"cancel",onClick:this.onCancel,label:t("actions.cancel"),baseStyle:"gdt"}),i.default.createElement(d.default,{type:"apply",onClick:this.onApply,label:t("actions.apply"),baseStyle:"gdt"}))):i.default.createElement("div",{className:o,style:{padding:"5px"},onClick:this.startEditing},n)}}]),t}(),a.propTypes={i18n:s.default.func.isRequired,onApply:s.default.func.isRequired,onCancel:s.default.func,content:s.default.string,readOnly:s.default.bool,editing:s.default.bool},a.defaultProps={onCancel:null,content:null,readOnly:!1,editing:!1},r=o))||r;t.default=f},function(e,t){e.exports=__webpack_require__(195)},function(e,t){}]);
	//# sourceMappingURL=ReactComponents.js.map

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	/**
	 * Clamps `number` within the inclusive `lower` and `upper` bounds.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Number
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 * @example
	 *
	 * _.clamp(-10, -5, 5);
	 * // => -5
	 *
	 * _.clamp(10, -5, 5);
	 * // => 5
	 */
	function clamp(number, lower, upper) {
	  if (upper === undefined) {
	    upper = lower;
	    lower = undefined;
	  }
	  if (upper !== undefined) {
	    upper = toNumber(upper);
	    upper = upper === upper ? upper : 0;
	  }
	  if (lower !== undefined) {
	    lower = toNumber(lower);
	    lower = lower === lower ? lower : 0;
	  }
	  return baseClamp(toNumber(number), lower, upper);
	}
	
	module.exports = clamp;


/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _componentsModule = __webpack_require__(15);
	
	var _componentsModule2 = _interopRequireDefault(_componentsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(size) {
	  return {
	    width: size + 'px',
	    lineHeight: size + 'px',
	    height: size + 'px'
	  };
	};
	
	var Circle = function Circle(_ref) {
	  var content = _ref.content,
	      className = _ref.className,
	      size = _ref.size;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_componentsModule2.default.circle, className), style: getStyles(size) },
	    content
	  );
	};
	
	Circle.propTypes = {
	  className: _propTypes.string,
	  content: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired,
	  size: _propTypes.number.isRequired
	};
	
	Circle.defaultProps = {
	  className: ''
	};
	
	exports.default = Circle;
	module.exports = exports['default'];

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactComponents = __webpack_require__(140);
	
	var _RoundCaption = __webpack_require__(105);
	
	var _RoundCaption2 = _interopRequireDefault(_RoundCaption);
	
	var _collapsibleModule = __webpack_require__(179);
	
	var _collapsibleModule2 = _interopRequireDefault(_collapsibleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collapsible = function (_React$PureComponent) {
	  _inherits(Collapsible, _React$PureComponent);
	
	  function Collapsible(props) {
	    _classCallCheck(this, Collapsible);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.state = {
	      collapsed: true
	    };
	
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    _this.handleExpand = _this.handleExpand.bind(_this);
	    return _this;
	  }
	
	  Collapsible.prototype.handleCollapse = function handleCollapse() {
	    this.setState({ collapsed: true });
	  };
	
	  Collapsible.prototype.handleExpand = function handleExpand() {
	    this.setState({ collapsed: false });
	  };
	
	  Collapsible.prototype.render = function render() {
	    var _props$children = this.props.children,
	        Caption = _props$children[0],
	        Content = _props$children[1];
	    var collapsed = this.state.collapsed;
	
	    var containerClass = collapsed ? _collapsibleModule2.default.collapsibleContainer : _collapsibleModule2.default.collapsibleContainerExpanded;
	    var toggleClass = collapsed ? _collapsibleModule2.default.collapsibleContainerToggle : _collapsibleModule2.default.collapsibleContainerToggleExpanded;
	
	    return _react2.default.createElement(
	      _reactComponents.DynamicHeightContainer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: containerClass },
	        _react2.default.createElement(
	          _RoundCaption2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            {
	              className: _collapsibleModule2.default.collapsibleCaption,
	              onClick: collapsed ? this.handleExpand : this.handleCollapse },
	            _react2.default.createElement(
	              'div',
	              { className: _collapsibleModule2.default.collapsibleCaptionContent },
	              Caption
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: toggleClass },
	              _react2.default.createElement('button', { className: collapsed ? 'collapsed' : 'expanded' })
	            )
	          )
	        ),
	        this.state.collapsed ? null : _react2.default.createElement(
	          'div',
	          { className: _collapsibleModule2.default.collapsibleContainerContent },
	          Content
	        )
	      )
	    );
	  };
	
	  return Collapsible;
	}(_react2.default.PureComponent);
	
	exports.default = Collapsible;
	module.exports = exports['default'];

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _headersModule = __webpack_require__(92);
	
	var _headersModule2 = _interopRequireDefault(_headersModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderWithIcon = function HeaderWithIcon(_ref) {
	  var type = _ref.type,
	      title = _ref.title;
	  return _react2.default.createElement(
	    'div',
	    { className: _headersModule2.default[type + 'HeaderWithIcon'] },
	    title
	  );
	};
	
	HeaderWithIcon.propTypes = {
	  type: (0, _propTypes.oneOf)(['research', 'summary', 'question', 'assessment']).isRequired,
	  title: _propTypes.string.isRequired
	};
	
	exports.default = HeaderWithIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(14);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _lodash = __webpack_require__(124);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _Circle = __webpack_require__(104);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	var _componentsModule = __webpack_require__(15);
	
	var _componentsModule2 = _interopRequireDefault(_componentsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultToggle = function DefaultToggle(_ref) {
	  var currentValue = _ref.currentValue,
	      dragging = _ref.dragging;
	  return _react2.default.createElement(_Circle2.default, {
	    className: currentValue !== null ? null : _componentsModule2.default.rangeInputToggleNoValue,
	    content: currentValue !== null ? currentValue : '',
	    size: 40
	  });
	};
	
	var RangeInputTickMark = function RangeInputTickMark(_ref2) {
	  var value = _ref2.value,
	      label = _ref2.label,
	      style = _ref2.style;
	  return _react2.default.createElement(
	    'div',
	    { className: _componentsModule2.default.rangeInputTickMark, style: style },
	    _react2.default.createElement(
	      'div',
	      { className: _componentsModule2.default.rangeInputTickMarkValue },
	      value
	    ),
	    _react2.default.createElement('div', { className: _componentsModule2.default.rangeInputTickMarkSymbol }),
	    _react2.default.createElement(
	      'div',
	      { className: _componentsModule2.default.rangeInputTickMarkLabel },
	      label
	    )
	  );
	};
	
	var captureMoveEvents = function captureMoveEvents(onMoveCb, onMoveEndCb) {
	  // there should be no other react on movements other than ours
	  var bodyPointerEvents = document.body.style['pointer-events'];
	  var bodyUserSelect = document.body.style['user-select'];
	  document.body.style['pointer-events'] = 'none';
	  document.body.style['user-select'] = document.body.style['-moz-user-select'] = document.body.style['-ms-user-select'] = document.body.style['-webkit-user-select'] = 'none';
	  // this will restore body styles and unregister callbacks once mouse is up
	  var removeListeners = function removeListeners(evt) {
	    document.removeEventListener('mousemove', onMoveCb);
	    document.removeEventListener('mouseup', removeListeners);
	    document.body.style['pointer-events'] = bodyPointerEvents;
	    document.body.style['user-select'] = document.body.style['-moz-user-select'] = document.body.style['-ms-user-select'] = document.body.style['-webkit-user-select'] = bodyUserSelect;
	    onMoveEndCb(evt);
	  };
	  // start capturing
	  document.addEventListener('mousemove', onMoveCb);
	  document.addEventListener('mouseup', removeListeners);
	};
	
	var RangeInput = function (_React$PureComponent) {
	  _inherits(RangeInput, _React$PureComponent);
	
	  function RangeInput(props) {
	    _classCallCheck(this, RangeInput);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.state = {
	      containerLeft: 0,
	      dragging: false,
	      stepLength: 1
	    };
	
	    _this.updateRangeValueFromPointerPosition = _this.updateRangeValueFromPointerPosition.bind(_this);
	    _this.handleTrackClick = _this.handleTrackClick.bind(_this);
	    _this.handleToggleMouseDown = _this.handleToggleMouseDown.bind(_this);
	    _this.handleToggleMove = _this.handleToggleMove.bind(_this);
	    _this.handleToggleMoveEnd = _this.handleToggleMoveEnd.bind(_this);
	    _this.handleDec = _this.handleDec.bind(_this);
	    _this.handleInc = _this.handleInc.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.rangeRef = _this.rangeRef.bind(_this);
	    _this._measureDOM = _this._measureDOM.bind(_this);
	    return _this;
	  }
	
	  RangeInput.prototype.rangeRef = function rangeRef(el) {
	    this.rangeEl = el;
	  };
	
	  RangeInput.prototype._measureDOM = function _measureDOM() {
	    var _props = this.props,
	        max = _props.max,
	        min = _props.min,
	        step = _props.step;
	
	    var _rangeEl$getBoundingC = this.rangeEl.getBoundingClientRect(),
	        width = _rangeEl$getBoundingC.width,
	        left = _rangeEl$getBoundingC.left;
	
	    var numOfSteps = (max - min) / step;
	
	    return {
	      stepLength: width / numOfSteps,
	      containerLeft: left
	    };
	  };
	
	  RangeInput.prototype.getValueOffset = function getValueOffset(value) {
	    var _props2 = this.props,
	        min = _props2.min,
	        max = _props2.max,
	        step = _props2.step;
	
	    var clampedValue = (0, _lodash2.default)(value, min, max);
	    var numOfSteps = (max - min) / step;
	    // number of steps to make from min to provided value
	    var stepsToVal = (clampedValue - min) / step;
	
	    return stepsToVal / numOfSteps * 100 + '%';
	  };
	
	  RangeInput.prototype.updateRangeValueFromPointerPosition = function updateRangeValueFromPointerPosition(pointerX) {
	    if (this.props.readonly) return;
	
	    var _props3 = this.props,
	        min = _props3.min,
	        max = _props3.max,
	        step = _props3.step,
	        value = _props3.value;
	    var _state = this.state,
	        stepLength = _state.stepLength,
	        containerLeft = _state.containerLeft;
	
	    var stepIndex = Math.round((pointerX - containerLeft) / stepLength);
	    var stepValue = min + stepIndex * step;
	    var clampedStepValue = (0, _lodash2.default)(stepValue, min, max);
	
	    if (clampedStepValue !== value) {
	      this.props.onChange(clampedStepValue);
	    }
	  };
	
	  RangeInput.prototype.handleTrackClick = function handleTrackClick(evt) {
	    var _this2 = this;
	
	    var clientX = evt.clientX;
	
	    this.setState(this._measureDOM(), function () {
	      return _this2.updateRangeValueFromPointerPosition(clientX);
	    });
	  };
	
	  RangeInput.prototype.handleToggleMove = function handleToggleMove(evt) {
	    evt.stopPropagation();
	    this.updateRangeValueFromPointerPosition(evt.clientX);
	  };
	
	  RangeInput.prototype.handleToggleMouseDown = function handleToggleMouseDown(evt) {
	    if (this.props.readonly) return;
	    // do not react on arrow buttons mouse down
	    if (evt.target.classList.contains(_componentsModule2.default.rangeInputToggleLeftArrow) || evt.target.classList.contains(_componentsModule2.default.rangeInputToggleRightArrow)) {
	      return;
	    }
	    this.setState(_underscore2.default.extend(this._measureDOM(), {
	      dragging: true
	    }));
	    captureMoveEvents(this.handleToggleMove, this.handleToggleMoveEnd);
	  };
	
	  RangeInput.prototype.handleToggleMoveEnd = function handleToggleMoveEnd(evt) {
	    this.setState({
	      dragging: false
	    });
	  };
	
	  RangeInput.prototype.handleInc = function handleInc() {
	    var _props4 = this.props,
	        value = _props4.value,
	        max = _props4.max,
	        onChange = _props4.onChange,
	        step = _props4.step;
	
	    if (value === max) return;
	    var incremented = value + step;
	    return onChange(incremented > max ? max : incremented);
	  };
	
	  RangeInput.prototype.handleDec = function handleDec() {
	    var _props5 = this.props,
	        value = _props5.value,
	        min = _props5.min,
	        onChange = _props5.onChange,
	        step = _props5.step;
	
	    if (value === min) return;
	    var decremented = value - step;
	    return onChange(decremented < min ? min : decremented);
	  };
	
	  RangeInput.prototype.handleKeyDown = function handleKeyDown(evt) {
	    // prevent scrolling with arrow keys
	    evt.preventDefault();
	
	    switch (evt.keyCode) {
	      case 37:
	      case 40:
	        return this.handleDec();
	      case 38:
	      case 39:
	        return this.handleInc();
	    }
	  };
	
	  RangeInput.prototype.renderTickMarks = function renderTickMarks() {
	    var _this3 = this;
	
	    var _props6 = this.props,
	        min = _props6.min,
	        max = _props6.max,
	        tickMarkStep = _props6.tickMarkStep,
	        tickMarkLabels = _props6.tickMarkLabels,
	        showTickMarkValues = _props6.showTickMarkValues;
	
	    var tickVals = _underscore2.default.range(min, max, tickMarkStep).concat(max);
	
	    return tickVals.map(function (tickVal, idx) {
	      return _react2.default.createElement(RangeInputTickMark, {
	        value: showTickMarkValues || idx === 0 || idx === tickVals.length - 1 ? tickVal : null,
	        key: tickVal,
	        style: idx === tickVals.length - 1 ? null : { left: _this3.getValueOffset(tickVal) },
	        label: tickMarkLabels[tickVal]
	      });
	    });
	  };
	
	  RangeInput.prototype.renderToggle = function renderToggle() {
	    var _props7 = this.props,
	        Toggle = _props7.Toggle,
	        value = _props7.value,
	        min = _props7.min,
	        max = _props7.max,
	        withToggleArrows = _props7.withToggleArrows,
	        readonly = _props7.readonly;
	    // TODO: add Touch events to support touch screen users if needed
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _componentsModule2.default.rangeInputToggle,
	        onMouseDown: this.handleToggleMouseDown,
	        style: { left: this.getValueOffset(value) } },
	      withToggleArrows && !readonly ? [value > min ? _react2.default.createElement('button', {
	        key: 'arrowDec',
	        className: _componentsModule2.default.rangeInputToggleLeftArrow,
	        onClick: this.handleDec
	      }) : null, value < max ? _react2.default.createElement('button', {
	        key: 'arrowInc',
	        className: _componentsModule2.default.rangeInputToggleRightArrow,
	        onClick: this.handleInc
	      }) : null] : null,
	      _react2.default.createElement(Toggle, { currentValue: value, dragging: this.state.dragging })
	    );
	  };
	
	  RangeInput.prototype.render = function render() {
	    var _props8 = this.props,
	        scaleBarClass = _props8.scaleBarClass,
	        tickMarkClass = _props8.tickMarkClass,
	        min = _props8.min,
	        max = _props8.max,
	        minLabel = _props8.minLabel,
	        maxLabel = _props8.maxLabel;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _componentsModule2.default.rangeInput,
	        onKeyDown: this.handleKeyDown,
	        ref: this.rangeRef,
	        tabIndex: -1 },
	      _react2.default.createElement('div', { className: (0, _classnames2.default)(_componentsModule2.default.rangeInputTrack, scaleBarClass) }),
	      _react2.default.createElement(
	        'div',
	        { className: _componentsModule2.default.rangeInputTickMarks, onClick: this.handleTrackClick },
	        this.renderTickMarks()
	      ),
	      this.renderToggle()
	    );
	  };
	
	  return RangeInput;
	}(_react2.default.PureComponent);
	
	RangeInput.propTypes = {
	  max: _propTypes.number.isRequired,
	  min: _propTypes.number.isRequired,
	  onChange: _propTypes.func,
	  readonly: _propTypes.bool,
	  scaleBarClass: _propTypes.string,
	  step: _propTypes.number,
	  Toggle: _propTypes.func,
	  tickMarkClass: _propTypes.string,
	  tickMarkStep: _propTypes.number,
	  tickMarkLabels: _propTypes.object,
	  value: _propTypes.number,
	  withToggleArrows: _propTypes.bool,
	  showTickMarkValues: _propTypes.bool
	};
	RangeInput.defaultProps = {
	  readonly: false,
	  scaleBarClass: '',
	  step: 1,
	  tickMarkClass: '',
	  tickMarkStep: 1,
	  tickMarkLabels: {},
	  Toggle: DefaultToggle,
	  value: 0,
	  withToggleArrows: true,
	  showTickMarkValues: true
	};
	exports.default = RangeInput;
	module.exports = exports['default'];

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsModule = __webpack_require__(15);
	
	var _componentsModule2 = _interopRequireDefault(_componentsModule);
	
	var _propTypes = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var captionInlineStyles = function captionInlineStyles(height) {
	  return {
	    height: height + 'px',
	    borderRadius: height / 2 + 'px',
	    padding: '0 ' + height / 2 + 'px',
	    marginBottom: '6px'
	  };
	};
	
	var RoundCaption = function RoundCaption(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _componentsModule2.default.roundCaption, style: captionInlineStyles(props.height) },
	    props.children
	  );
	};
	
	RoundCaption.propTypes = {
	  height: _propTypes.number
	};
	
	RoundCaption.defaultProps = {
	  height: 56
	};
	
	exports.default = RoundCaption;
	module.exports = exports['default'];

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _immutable = __webpack_require__(4);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SectionTitle = __webpack_require__(146);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _TextContent = __webpack_require__(39);
	
	var _TextContent2 = _interopRequireDefault(_TextContent);
	
	var _SectionImage = __webpack_require__(145);
	
	var _SectionImage2 = _interopRequireDefault(_SectionImage);
	
	var _contentModule = __webpack_require__(32);
	
	var _contentModule2 = _interopRequireDefault(_contentModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Section = function Section(_ref) {
	  var section = _ref.section;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _contentModule2.default.section },
	    section.get('image') && _react2.default.createElement(_SectionImage2.default, { image: section.get('image') }),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_SectionTitle2.default, { sectionTitle: section.get('title') }),
	      _react2.default.createElement(_TextContent2.default, { content: section.get('content') })
	    )
	  );
	};
	
	exports.default = Section;
	module.exports = exports['default'];

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _immutable = __webpack_require__(4);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _contentModule = __webpack_require__(32);
	
	var _contentModule2 = _interopRequireDefault(_contentModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO I'm assuming that src of image will be base64, otherwise this component will require some
	// improvements
	var SectionImage = function SectionImage(_ref) {
	  var image = _ref.image,
	      type = _ref.type;
	
	  var position = image.get('position');
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_contentModule2.default.sectionImage, _contentModule2.default[position], _contentModule2.default[type]) },
	    _react2.default.createElement('img', { src: image.get('src') })
	  );
	};
	
	SectionImage.propTypes = {
	  image: (0, _propTypes.instanceOf)(_immutable2.default.Map).isRequired,
	  type: (0, _propTypes.oneOf)(['circle', 'normal'])
	};
	
	SectionImage.defaultProps = {
	  type: 'circle'
	};
	
	exports.default = SectionImage;
	module.exports = exports['default'];

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionTitle = function SectionTitle(_ref) {
	  var sectionTitle = _ref.sectionTitle;
	  return _react2.default.createElement(
	    'h2',
	    null,
	    sectionTitle
	  );
	};
	
	SectionTitle.propTypes = {
	  sectionTitle: _propTypes.string.isRequired
	};
	
	exports.default = SectionTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(54);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _navigationModule = __webpack_require__(52);
	
	var _navigationModule2 = _interopRequireDefault(_navigationModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArrowLink = function ArrowLink(_ref) {
	  var type = _ref.type,
	      linkTo = _ref.linkTo,
	      linkText = _ref.linkText;
	
	  var arrowClassName = type === 'left' ? _navigationModule2.default.arrowLeft : _navigationModule2.default.arrowRight;
	  return linkTo && _react2.default.createElement(
	    _gatsbyLink2.default,
	    { className: arrowClassName, to: linkTo },
	    linkText
	  );
	};
	
	ArrowLink.propTypes = {
	  type: (0, _propTypes.oneOf)(['left', 'right']).isRequired,
	  linkTo: _propTypes.string,
	  linkText: _propTypes.string
	};
	
	ArrowLink.defaultProps = {
	  linkTo: null,
	  linkText: null
	};
	
	exports.default = ArrowLink;
	module.exports = exports['default'];

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _ArrowLink = __webpack_require__(80);
	
	var _ArrowLink2 = _interopRequireDefault(_ArrowLink);
	
	var _navigationModule = __webpack_require__(52);
	
	var _navigationModule2 = _interopRequireDefault(_navigationModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArrowNavigation = function ArrowNavigation(_ref) {
	  var prevLink = _ref.prevLink,
	      nextLink = _ref.nextLink,
	      prevLinkText = _ref.prevLinkText,
	      nextLinkText = _ref.nextLinkText;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _navigationModule2.default.arrowNavigation },
	    _react2.default.createElement(
	      'div',
	      { className: _navigationModule2.default.navigationArrow },
	      _react2.default.createElement(_ArrowLink2.default, { type: 'left', linkTo: prevLink, linkText: prevLinkText })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _navigationModule2.default.navigationArrow },
	      _react2.default.createElement(_ArrowLink2.default, { type: 'right', linkTo: nextLink, linkText: nextLinkText })
	    )
	  );
	};
	
	ArrowNavigation.propTypes = {
	  prevLink: _propTypes.string,
	  nextLink: _propTypes.string,
	  prevLinkText: _propTypes.string,
	  nextLinkText: _propTypes.string
	};
	
	ArrowNavigation.defaultProps = {
	  prevLink: null,
	  nextLink: null,
	  prevLinkText: 'back',
	  nextLinkText: 'next'
	};
	
	exports.default = ArrowNavigation;
	module.exports = exports['default'];

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _underscore = __webpack_require__(14);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(124);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RangeInput = __webpack_require__(143);
	
	var _RangeInput2 = _interopRequireDefault(_RangeInput);
	
	var _RoundCaption = __webpack_require__(105);
	
	var _RoundCaption2 = _interopRequireDefault(_RoundCaption);
	
	var _outcomesValueAssessmentModule = __webpack_require__(572);
	
	var _outcomesValueAssessmentModule2 = _interopRequireDefault(_outcomesValueAssessmentModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OutcomeText = function OutcomeText(props) {
	  var name = props.name,
	      textBefore = props.textBefore,
	      textAfter = props.textAfter;
	
	  return _react2.default.createElement(
	    'h3',
	    null,
	    _react2.default.createElement(
	      'span',
	      null,
	      textBefore
	    ),
	    _react2.default.createElement(
	      'a',
	      null,
	      ' ',
	      name,
	      ' '
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      textAfter,
	      ' '
	    )
	  );
	};
	
	OutcomeText.propTypes = {
	  textAfter: _propTypes.string.isRequired,
	  textBefore: _propTypes.string.isRequired,
	  name: _propTypes.string.isRequired
	};
	
	OutcomeText.defaultProps = {
	  textBefore: 'In my opinion having a',
	  textAfter: 'is equivalent to:'
	};
	
	var OutcomeValueAssessment = function (_React$PureComponent) {
	  _inherits(OutcomeValueAssessment, _React$PureComponent);
	
	  function OutcomeValueAssessment(props) {
	    _classCallCheck(this, OutcomeValueAssessment);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.emitChange = _this.emitChange.bind(_this);
	    _this.handleInputValueChange = _this.handleInputValueChange.bind(_this);
	    return _this;
	  }
	
	  OutcomeValueAssessment.prototype.emitChange = function emitChange(value) {
	    this.props.onChange({
	      outcomeId: this.props.outcome.key,
	      value: value
	    });
	  };
	
	  OutcomeValueAssessment.prototype.handleInputValueChange = function handleInputValueChange(evt) {
	    var value = Number(evt.target.value);
	    if (_underscore2.default.isFinite(value)) {
	      var clampedValue = (0, _lodash2.default)(value, 0, 100);
	
	      this.emitChange(clampedValue);
	    } else {
	      return evt.preventDefault();
	    }
	  };
	
	  OutcomeValueAssessment.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.value,
	        outcome = _props.outcome,
	        className = _props.className,
	        minValue = _props.minValue,
	        maxValue = _props.maxValue;
	
	    var containerClassName = (0, _classnames2.default)(_outcomesValueAssessmentModule2.default.outcomeValueAssessment, className);
	    return _react2.default.createElement(
	      'div',
	      { className: containerClassName },
	      _react2.default.createElement(
	        'div',
	        { className: _outcomesValueAssessmentModule2.default.outcomeValueAssessmentCaption },
	        _react2.default.createElement(OutcomeText, { name: outcome.marker, textBefore: outcome.markerPrefix }),
	        _react2.default.createElement('input', { onChange: this.handleInputValueChange, type: 'text', value: value })
	      ),
	      _react2.default.createElement(
	        _RoundCaption2.default,
	        null,
	        _react2.default.createElement(_RangeInput2.default, {
	          onChange: this.emitChange,
	          min: minValue,
	          max: maxValue,
	          step: 5,
	          scaleBarClass: _outcomesValueAssessmentModule2.default.markerStateScale,
	          tickMarkStep: 50,
	          tickMarkLabels: {
	            0: 'Dead',
	            100: 'Good Health'
	          },
	          value: value
	        })
	      )
	    );
	  };
	
	  return OutcomeValueAssessment;
	}(_react2.default.PureComponent);
	
	OutcomeValueAssessment.propTypes = {
	  className: _propTypes.string,
	  outcome: (0, _propTypes.shape)({
	    key: _propTypes.string.isRequired,
	    marker: _propTypes.string.isRequired
	  }).isRequired,
	  maxValue: _propTypes.number,
	  minValue: _propTypes.number,
	  onChange: _propTypes.func.isRequired,
	  value: _propTypes.number
	};
	OutcomeValueAssessment.defaultProps = {
	  value: 50,
	  minValue: 0,
	  maxValue: 100
	};
	exports.default = OutcomeValueAssessment;
	module.exports = exports['default'];

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(45);
	
	var _outcomeValue = __webpack_require__(403);
	
	var _OutcomeValueAssessment = __webpack_require__(389);
	
	var _OutcomeValueAssessment2 = _interopRequireDefault(_OutcomeValueAssessment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    outcomeValues: state.get('outcomeValues')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setOutcomeValue: function setOutcomeValue(outcomeId, value) {
	      return dispatch((0, _outcomeValue.setOutcomeValue)(outcomeId, value));
	    }
	  };
	};
	
	var OutcomesValueAssessment = function OutcomesValueAssessment(_ref) {
	  var outcomes = _ref.outcomes,
	      setOutcomeValue = _ref.setOutcomeValue,
	      outcomeValues = _ref.outcomeValues;
	  return _react2.default.createElement(
	    'div',
	    null,
	    outcomes.map(function (outcome, index) {
	      var value = outcomeValues.get(outcome.get('key'));
	      return _react2.default.createElement(_OutcomeValueAssessment2.default, {
	        key: index,
	        outcome: outcome.toJS(),
	        onChange: setOutcomeValue,
	        value: value
	      });
	    })
	  );
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OutcomesValueAssessment);
	module.exports = exports['default'];

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.setOutcomeValue = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actionTypes = __webpack_require__(40);
	
	var setOutcomeValue = exports.setOutcomeValue = function setOutcomeValue(actionPayload) {
	  return _extends({ type: _actionTypes.SET_OUTCOME_VALUE }, actionPayload);
	};

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"collapsibleContainer":"src-styles----collapsible-module---collapsibleContainer---2AsBX","collapsibleContainerExpanded":"src-styles----collapsible-module---collapsibleContainerExpanded---3Xnwq src-styles----collapsible-module---collapsibleContainer---2AsBX","collapsibleCaption":"src-styles----collapsible-module---collapsibleCaption---1OLR9","collapsibleCaptionContent":"src-styles----collapsible-module---collapsibleCaptionContent---3jy1K","collapsibleContainerToggle":"src-styles----collapsible-module---collapsibleContainerToggle---2U_qa","collapsibleContainerToggleExpanded":"src-styles----collapsible-module---collapsibleContainerToggleExpanded---s0Jzv src-styles----collapsible-module---collapsibleContainerToggle---2U_qa","collapsibleContainerContent":"src-styles----collapsible-module---collapsibleContainerContent---2d0ho"};

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"plainText":"src-styles----components-module---plainText---3wCQi","subTitle":"src-styles----components-module---subTitle---1j5pG","bold":"src-styles----components-module---bold---Rg4I5","blueText":"src-styles----components-module---blueText---njJLN","comparisonHeader":"src-styles----components-module---comparisonHeader---2i-9r","circle":"src-styles----components-module---circle---1Xo62","roundCaption":"src-styles----components-module---roundCaption---X1kKn","rangeInput":"src-styles----components-module---rangeInput---2r9kI","rangeInputTrack":"src-styles----components-module---rangeInputTrack---3WX3X","rangeInputToggle":"src-styles----components-module---rangeInputToggle---1Q60T","rangeInputToggleNoValue":"src-styles----components-module---rangeInputToggleNoValue---2niXM","rangeInputToggleDisabled":"src-styles----components-module---rangeInputToggleDisabled---ElmVB src-styles----components-module---rangeInputToggleNoValue---2niXM","rangeInputToggleLeftArrow":"src-styles----components-module---rangeInputToggleLeftArrow---2ex8R","rangeInputToggleRightArrow":"src-styles----components-module---rangeInputToggleRightArrow---3H5Y3","rangeInputTickMarks":"src-styles----components-module---rangeInputTickMarks---29HNB","rangeInputTickMark":"src-styles----components-module---rangeInputTickMark---1-AtU","rangeInputTickMarkValue":"src-styles----components-module---rangeInputTickMarkValue---36VH0","rangeInputTickMarkLabel":"src-styles----components-module---rangeInputTickMarkLabel---1-2Rz","rangeInputTickMarkSymbol":"src-styles----components-module---rangeInputTickMarkSymbol---1b7Ku","contentBox":"src-styles----components-module---contentBox---10uvH","blueContentBox":"src-styles----components-module---blueContentBox---3aOap src-styles----components-module---contentBox---10uvH","orangeContentBox":"src-styles----components-module---orangeContentBox---O-mD4 src-styles----components-module---contentBox---10uvH","grayContentBox":"src-styles----components-module---grayContentBox---1O8uz src-styles----components-module---contentBox---10uvH","contentBoxWithHeader":"src-styles----components-module---contentBoxWithHeader---1J-zE","contentBoxWithHeaderContent":"src-styles----components-module---contentBoxWithHeaderContent---1C3UN src-styles----components-module---plainText---3wCQi","riskQuestion":"src-styles----components-module---riskQuestion---37vGW","riskQuestionText":"src-styles----components-module---riskQuestionText---1ClSo","riskQuestionDetails":"src-styles----components-module---riskQuestionDetails---351Pl","riskRadioInputs":"src-styles----components-module---riskRadioInputs---3og-n","riskRadioInput":"src-styles----components-module---riskRadioInput---1GbHW","panelRecommendationsContainer":"src-styles----components-module---panelRecommendationsContainer---2oUrJ","panelRecommendation":"src-styles----components-module---panelRecommendation---33pJd","panelRecommendationContent":"src-styles----components-module---panelRecommendationContent---15KFO","otherRecommendationsToggler":"src-styles----components-module---otherRecommendationsToggler---13aKF","benefitsAndHarms":"src-styles----components-module---benefitsAndHarms---2mnoj","benefitsAndHarmsSeparator":"src-styles----components-module---benefitsAndHarmsSeparator---2v_Cq","benefitsAndHarmsContent":"src-styles----components-module---benefitsAndHarmsContent---1Z3eV","benefitsAndHarmsText":"src-styles----components-module---benefitsAndHarmsText---1GTa_","benefitsAndHarmsColumn":"src-styles----components-module---benefitsAndHarmsColumn----jJud","benefitsAndHarmsTitle":"src-styles----components-module---benefitsAndHarmsTitle---3_2Ix","modalContent":"src-styles----components-module---modalContent---quysN","modalCloseButton":"src-styles----components-module---modalCloseButton---2WHAd"};

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerWithIcon":"src-styles----headers-module---headerWithIcon---2oSfD","researchHeaderWithIcon":"src-styles----headers-module---researchHeaderWithIcon---1XcdP src-styles----headers-module---headerWithIcon---2oSfD","summaryHeaderWithIcon":"src-styles----headers-module---summaryHeaderWithIcon---wYgj0 src-styles----headers-module---headerWithIcon---2oSfD","questionHeaderWithIcon":"src-styles----headers-module---questionHeaderWithIcon---6WUMh src-styles----headers-module---headerWithIcon---2oSfD","assessmentHeaderWithIcon":"src-styles----headers-module---assessmentHeaderWithIcon---1nzJ0 src-styles----headers-module---headerWithIcon---2oSfD"};

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"outcomeValueAssessment":"src-styles----outcomesValueAssessment-module---outcomeValueAssessment---CsH5Z","outcomeValueAssessmentCaption":"src-styles----outcomesValueAssessment-module---outcomeValueAssessmentCaption---3tbgP","markerStateScale":"src-styles----outcomesValueAssessment-module---markerStateScale---2KsYz"};

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _immutable = __webpack_require__(4);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(14);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _ArrowNavigation = __webpack_require__(81);
	
	var _ArrowNavigation2 = _interopRequireDefault(_ArrowNavigation);
	
	var _Collapsible = __webpack_require__(142);
	
	var _Collapsible2 = _interopRequireDefault(_Collapsible);
	
	var _Header = __webpack_require__(79);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _HeaderWithIcon = __webpack_require__(78);
	
	var _HeaderWithIcon2 = _interopRequireDefault(_HeaderWithIcon);
	
	var _OutcomesValueAssessment = __webpack_require__(398);
	
	var _OutcomesValueAssessment2 = _interopRequireDefault(_OutcomesValueAssessment);
	
	var _Section = __webpack_require__(144);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _TextContent = __webpack_require__(39);
	
	var _TextContent2 = _interopRequireDefault(_TextContent);
	
	var _contentModule = __webpack_require__(32);
	
	var _contentModule2 = _interopRequireDefault(_contentModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Facts = function Facts(_ref) {
	  var location = _ref.location,
	      data = _ref.data,
	      props = _objectWithoutProperties(_ref, ['location', 'data']);
	
	  var nodeData = data.allJsonContentsJson.edges[0].node;
	  var markerStates = _immutable2.default.fromJS(nodeData.markerStates);
	  var processOutcomesExplanation = _immutable2.default.fromJS(nodeData.processOutcomesExplanation);
	  var keyFacts = _immutable2.default.fromJS(nodeData.keyFacts);
	  var _props$pathContext = props.pathContext,
	      pageId = _props$pathContext.pageId,
	      groupId = _props$pathContext.groupId,
	      subPage = _props$pathContext.subPage,
	      group = _props$pathContext.group;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, {
	      title: nodeData.title,
	      group: group,
	      location: location,
	      logo: nodeData.logo,
	      pageId: pageId,
	      groupId: groupId,
	      subPage: subPage
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _contentModule2.default.content },
	      _react2.default.createElement(_HeaderWithIcon2.default, { type: 'question', title: 'What should you know?' }),
	      keyFacts.map(function (section, key) {
	        return _react2.default.createElement(_Section2.default, { key: key, section: section });
	      }),
	      _react2.default.createElement(
	        'h2',
	        { className: _contentModule2.default.sectionTitle },
	        'Explanation of outcomes used in process:'
	      ),
	      processOutcomesExplanation.map(function (outcome, index) {
	        var markerState = markerStates.find(function (markerState) {
	          return markerState.get('key') === outcome;
	        });
	        return _react2.default.createElement(
	          _Collapsible2.default,
	          { key: index },
	          _react2.default.createElement(
	            'h4',
	            null,
	            markerState.get('explanationHeader')
	          ),
	          _react2.default.createElement(_TextContent2.default, { content: markerState.get('content') })
	        );
	      }),
	      _react2.default.createElement(_HeaderWithIcon2.default, { type: 'assessment', title: 'Assess your values' }),
	      _react2.default.createElement(_TextContent2.default, { content: 'To calculate an individual recommendation and to help understand how good or bad a health state is we have created the scales below with "dead" marked as 0 and "good health" marked as 100. We would like you to indicate on these scales how good or bad each health state is in your opinion:' }),
	      _react2.default.createElement(_OutcomesValueAssessment2.default, { outcomes: markerStates.filter(function (ms) {
	          return ms.get('marker');
	        }) }),
	      _react2.default.createElement(_ArrowNavigation2.default, { prevLink: '/' + pageId, nextLink: '/' + pageId + '/' + groupId + '/options' })
	    )
	  );
	};
	
	exports.default = Facts;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-facts-template-js-462d541d40e28a737d40.js